/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UsernameWithPopoverContainer_comment = {
    readonly id: string;
    readonly author: {
        readonly id: string;
        readonly username: string | null;
        readonly " $fragmentRefs": FragmentRefs<"UserPopoverContainer_user">;
    } | null;
    readonly " $refType": "UsernameWithPopoverContainer_comment";
};
export type UsernameWithPopoverContainer_comment$data = UsernameWithPopoverContainer_comment;
export type UsernameWithPopoverContainer_comment$key = {
    readonly " $data"?: UsernameWithPopoverContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"UsernameWithPopoverContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "UsernameWithPopoverContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "username",
                        "storageKey": null
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "UserPopoverContainer_user"
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '9e6295bbf4042968e050b953fb2ecfc2';
export default node;
